import { memo } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { ResponsiveFunnel } from '@nivo/funnel';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const data = [
  {
    "id": "step_sent",
    "value": 79,
    "label": "Sent messages"
  },
  {
    "id": "step_replies",
    "value": 34,
    "label": "Replies"
  },
  {
    "id": "step_visits",
    "value": 9,
    "label": "Visits scheduled"
  }
]

const AnalyticsWidget = () => {

  return (
    <Card sx={{ width: '100%', maxWidth: 640, height: 500, p: 2 }}>
      <Box sx={{ width:  '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', pt: 1, pb: 3 }}>
        <Typography sx={{ fontSize: '1.25rem', fontWeight: 800 }}>Analytics</Typography>
      </Box>
      <ResponsiveFunnel
        data={data}
        height={400}
        valueFormat=">-.0f"
        shapeBlending={0.14}
        colors={{ scheme: 'set2' }}
        borderWidth={20}
        labelColor="black"
        beforeSeparatorLength={100}
        beforeSeparatorOffset={20}
        afterSeparatorLength={100}
        afterSeparatorOffset={20}
        currentPartSizeExtension={10}
        currentBorderWidth={40}
        //animate={false}
        motionConfig="wobbly"
      />
    </Card>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <AnalyticsWidget {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);